document.addEventListener('DOMContentLoaded', () => { 
  const sliders = document.querySelectorAll('.bggle--slider-swiper');

  sliders.forEach((sliderEl) => {
    const pagination = sliderEl.querySelector('.swiper-pagination');

    new Swiper(sliderEl, {
      loop: true,
      slidesPerGroup: 3,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      // cấu hình mặc định (desktop)
      slidesPerView: 3,
      spaceBetween: 10,

      // responsive breakpoints
      breakpoints: {
        320: { // màn hình nhỏ hơn 320px
          slidesPerView: 1.2,
          spaceBetween: 8,
          slidesPerGroup: 1,
        },
        480: { // nhỏ hơn 480px
          slidesPerView: 1.5,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
        768: { // nhỏ hơn tablet
          slidesPerView: 2,
          spaceBetween: 12,
          slidesPerGroup: 2,
        },
        1024: { // tablet lớn
          slidesPerView: 3,
          spaceBetween: 15,
          slidesPerGroup: 3,
        }
      }
    });
  });
});